module.exports = __webpack_public_path__ + "static/media/see_darkbleu.2b549ec1.svg";